import styled from "styled-components";

export const ContainerHeaderGrid = styled.div`
	display: grid;
	grid-template-columns: 4fr 1fr;
	align-items: center;
	padding: 0.2rem;
	background-color: ${(props) => props.theme.white};
	border-bottom: 1px solid ${(props) => props.theme.icon};
`;

export const TitleType = styled.div`
	font-weight: 400;
	color: ${(props) => props.theme.pantone2726C};
	width: 100%;
	padding: 0 0.5rem;
	overflow-wrap: break-word;
	word-break: break-word;
	white-space: normal;
	flex: 1;
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 16px;
	gap: 8px;
`;

export const GridContainer = styled.div`
	max-height: 400px;
	overflow-y: auto;
	border: 1px solid ${(props) => props.theme.icon};
	border-radius: 4px;
`;

export const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 16px;
`;

export const Spinner = styled.div`
	border: 3px solid rgba(0, 0, 0, 0.1);
	border-left-color: ${(props) => props.theme.pantone2726C};
	border-radius: 50%;
	width: 20px;
	height: 20px;
	animation: spin 1s linear infinite;
	margin: 0 10px;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;

export const TitleGrid = styled.div`
	font-weight: bold;
	color: ${(props) => props.theme.pantone2726C};
	margin-bottom: 8px;
`;

export const NoDataContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 32px;
	color: ${(props) => props.theme.icon};
`;

export const TitlerCount = styled.div`
	font-weight: bold;
	color: #000;
	margin-top: 10px;
`;

export const ContainerScroll = styled.div`
	max-height: 450px;
	overflow-y: auto;

	div > #id-general-boxgrid > table {
		min-width: 0;
	}
`;
